import axios from "../axios-interceptor.js"
import { errorResponse, successResponse } from "./SpaceServices.js";

let tenantId = localStorage.getItem("tenantId")
const BACKEND_API = "https://estimate-engine-dot-saltoris-elit.el.r.appspot.com";

export const getEstimationData = async (spaceId) => {
    let data = {};
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/get/${spaceId}`,
            headers: {
                userId: 1,
            },
        })
        data = response.data
    }
    catch {

    }
    return data;
}

export const saveEstimationData = async (postData, spaceId) => {
    let data = [];
    try {
        let response = await axios({
            method: "POST",
            url: `${BACKEND_API}/save/${spaceId}`,
            data: postData
        })
        let rolesData = response?.data?.result || []
            data = rolesData.map(role => {
                return { ...role, label: role.role, value: role.role }
        })
    }
    catch {

    }
    return data;
}